import React, { useContext, useEffect, useState } from 'react'
import CustomAddPage from '../../../components/CustomComponents/CustomAddPage'
import { CategoryContext } from '../../../context api/Category/CategoryContext'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { ProductContext } from '../../../context api/Product/ProductContext'
import { SubCategoryContext } from '../../../context api/SubCategory/SubCategoryContext'
import { useCategory } from '../../../hooks/Features/useCategory'
import { useProduct } from '../../../hooks/Features/useProduct'
import { useSubCategory } from '../../../hooks/Features/useSubCategory'
import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'
import { useTrainingCategoryContent } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategoryContent'
import { isArray, sortByName, uploadFilesToAws } from '../../../shared/constants'
import { booleanOptions } from '../../../utils/otherHelper'
import moment from 'moment'
import { TrainRounded } from '@material-ui/icons'

export default function AddTrainingCategoryContent({ trainingCategoryContent }) {
  const [trainingCategoryContentData, setTrainingCategoryContentData] = useState({
    trainingCategory: null,
    name: '',
    description: '',
    active: false,
    video: '',
    videoUrl: '',
    pdf: '',
    ppt: '',
    startDate: new Date(),
    expiryDate: moment().add(1, 'month'),
    contentThumbnail: '',
    duration: '',
    isProductCategory: false,
    isMonthlyTrainingCategory: false,
    category: null,
    subCategory: null,
    product: null,
    metaTags: [],
  })
  console.log('trainingCategoryContentData : ', trainingCategoryContentData)
  const { addTrainingCategoryContent, loading, updateTrainingCategoryContent } = useTrainingCategoryContent()
  const { getAllTrainingCategories } = useTrainingCategory()
  const { trainingCategories } = useContext(OtherContext)
  const { getAllCategories } = useCategory()
  const { getAllSubCategory } = useSubCategory()
  const { getAllProducts } = useProduct()
  const { categories } = useContext(CategoryContext)
  const { subcategories } = useContext(SubCategoryContext)
  const { products } = useContext(ProductContext)
  const [uploadLoading, setUploadLoading] = useState(false)
  useEffect(() => {
    getAllCategories()
    getAllTrainingCategories()
  }, [])

  useEffect(() => {
    if (trainingCategoryContentData.category) {
      getAllSubCategory({ categoryId: trainingCategoryContentData.category })
    }
  }, [trainingCategoryContentData.category])

  useEffect(() => {
    if (trainingCategoryContentData.category && trainingCategoryContentData.subCategory) {
      getAllProducts({ categoryId: trainingCategoryContentData.category, subCategoryId: trainingCategoryContentData.subCategory })
    }
  }, [trainingCategoryContentData.category, trainingCategoryContentData.subCategory])

  const handleTrainingCategoryContent = async () => {
    let tempVideo = trainingCategoryContentData.video
    let tempPdf = trainingCategoryContentData.pdf
    let tempPpt = trainingCategoryContentData.ppt
    let tempThumbnail = trainingCategoryContentData.contentThumbnail

    if (tempVideo && !isArray(tempVideo)) tempVideo = await uploadFilesToAws(tempVideo, setUploadLoading)

    if (tempPdf && !isArray(tempPdf)) tempPdf = await uploadFilesToAws(tempPdf, setUploadLoading)

    if (tempPpt && !isArray(tempPpt)) tempPpt = await uploadFilesToAws(tempPpt, setUploadLoading)
    if (tempThumbnail && !isArray(tempThumbnail)) tempThumbnail = await uploadFilesToAws(tempThumbnail, setUploadLoading)

    if (trainingCategoryContent) {
      updateTrainingCategoryContent({
        ...trainingCategoryContentData,
        trainingCategoryContentId: trainingCategoryContent._id,
        video: tempVideo ? tempVideo[0] : '',
        pdf: tempPdf ? tempPdf[0] : '',
        ppt: tempPpt ? tempPpt[0] : '',
        contentThumbnail: tempThumbnail ? tempThumbnail[0] : '',
      })
    } else {
      addTrainingCategoryContent({
        ...trainingCategoryContentData,
        video: tempVideo ? tempVideo[0] : '',
        pdf: tempPdf ? tempPdf[0] : '',
        ppt: tempPpt ? tempPpt[0] : '',
        contentThumbnail: tempThumbnail ? tempThumbnail[0] : '',
      })
    }
  }

  useEffect(() => {
    if (trainingCategoryContent) {
      setTrainingCategoryContentData({
        ...trainingCategoryContent,
        video: [trainingCategoryContent.video],
        pdf: [trainingCategoryContent.pdf],
        ppt: [trainingCategoryContent.ppt],
        contentThumbnail: [trainingCategoryContent.contentThumbnail],
        trainingCategory: trainingCategoryContent.trainingCategory && trainingCategoryContent.trainingCategory._id,
        category: trainingCategoryContent.category,
        subCategory: trainingCategoryContent.subCategory,
        product: trainingCategoryContent.product,
      })
    }
  }, [trainingCategoryContent])

  const data = [
    { label: 'Content Name', value: trainingCategoryContentData.name, name: 'name' },

    { label: 'Training Category', value: trainingCategoryContentData.trainingCategory, name: 'trainingCategory', options: trainingCategories, fieldName: 'name', fieldValue: '_id' },
    { label: 'Start Date', value: trainingCategoryContentData.startDate, name: 'startDate', type: 'DATE' },
    { label: 'Expiry Date', value: trainingCategoryContentData.expiryDate, name: 'expiryDate', type: 'DATE' },
    { label: 'Description', value: trainingCategoryContentData.description, name: 'description', grid: 8 },

    { label: 'Content Duration (Minutes)', value: trainingCategoryContentData.duration, name: 'duration', type: 'NUMBER' },
    {
      label: 'Product Training Category',
      value: trainingCategoryContentData.isProductCategory,
      name: 'isProductCategory',
      options: booleanOptions,
      fieldName: 'label',
      fieldValue: 'value',
      noValidate: true,
    },
    {
      label: 'Monthly Training Category',
      value: trainingCategoryContentData.isMonthlyTrainingCategory,
      name: 'isMonthlyTrainingCategory',
      options: booleanOptions,
      fieldName: 'label',
      fieldValue: 'value',
      noValidate: true,
    },
    {
      label: 'Category',
      value: trainingCategoryContentData.category,
      name: 'category',
      options: sortByName(categories, 'categoryName'),
      fieldName: 'categoryName',
      fieldValue: '_id',
      noValidate: true,
      noDisplay: !trainingCategoryContentData.isProductCategory ? true : false,
    },
    {
      label: 'SubCategory',
      value: trainingCategoryContentData.subCategory,
      name: 'subCategory',
      options: sortByName(subcategories, 'name'),
      fieldName: 'name',
      fieldValue: '_id',
      noValidate: true,
      noDisplay: !trainingCategoryContentData.isProductCategory ? true : false,
      disabled: trainingCategoryContentData.category ? false : true,
    },
    {
      label: 'Product',
      value: trainingCategoryContentData.product,
      name: 'product',
      options: sortByName(products, 'name'),
      fieldName: 'name',
      fieldValue: '_id',
      noValidate: true,
      noDisplay: !trainingCategoryContentData.isProductCategory ? true : false,
      disabled: trainingCategoryContentData.category && trainingCategoryContentData.subCategory ? false : true,
    },
    { label: 'Video Url', value: trainingCategoryContentData.videoUrl, name: 'videoUrl', noValidate: true },
    {
      label: 'Video',
      value: trainingCategoryContentData.video,
      name: 'video',
      type: 'IMAGE',
      accept: 'video/*',
      restriction: ['Video Should Not be greater than 20 mb', 'WEBM video format not allowed'],
      limit: 20,
    },
    { label: 'PDF', value: trainingCategoryContentData.pdf, name: 'pdf', type: 'IMAGE', accept: '.pdf' },
    {
      label: 'PPT',
      value: trainingCategoryContentData.ppt,
      name: 'ppt',
      type: 'IMAGE',
      accept: '.ppt,.pptx',
      restriction: ['PPT Should Not be greater than 7 mb', 'Only PPT and PPTX format allowed'],
      limit: 700000,
    },
    { label: 'Thumbnail', value: trainingCategoryContentData.contentThumbnail, name: 'contentThumbnail', type: 'IMAGE', restriction: ['File Should Not be greater than 1 mb'] },
    { label: 'Status', value: trainingCategoryContentData.active, type: 'ACTIVE' },
    {
      label: 'Search Tags',
      value: trainingCategoryContentData.metaTags,
      type: 'CHIP',
      name: 'metaTags',
      grid: 12,

      // noDisplay: !trainingCategoryContentData.isProductCategory ? true : false,
    },
  ]

  return (
    <>
      <CustomAddPage
        heading="Training Category Content"
        redirect="ALL_TRAININGCATEGORYCONTENT"
        currentData={trainingCategoryContent}
        loading={loading}
        state={trainingCategoryContentData}
        setState={setTrainingCategoryContentData}
        handleClick={handleTrainingCategoryContent}
        inputFields={data}
        uploadLoading={uploadLoading}
      />
      {console.log(trainingCategoryContentData)}
    </>
  )
}
